<template>
  <el-row>
    <h6 style="text-align: left">余额变动明细</h6>
    <el-table
      :data="dataList"
      :row-class-name="tableRowClassName"
      border
      style="width: 100%">
      <el-table-column
        prop="id"
        label="#">
      </el-table-column>

      <el-table-column
        prop="preBalance"
        label="当前余额">
        <template slot-scope="scope">
          {{ scope.row.preBalance / 100 }} 元
        </template>
      </el-table-column>

      <el-table-column
        prop="delta"
        label="变化额度">
        <template slot-scope="scope">
          {{ scope.row.delta / 100 }} 元
        </template>
      </el-table-column>

      <el-table-column
        prop="curBalance"
        label="最新余额">
        <template slot-scope="scope">
          {{ scope.row.curBalance / 100 }} 元
        </template>
      </el-table-column>

      <el-table-column
        prop="reason"
        label="变动原因">
        <template slot-scope="scope">
          {{ scope.row.reason == 0 ? '提现' : (scope.row.reason == 1 ? '转账' : (scope.row.reason == 2 ? '分润' : '管理员操作')) }}
        </template>
      </el-table-column>

      <el-table-column
        prop="createAt"
        sortable
        label="发生时间">
      </el-table-column>
    </el-table>
  </el-row>
</template>

<script>
export default {
  name: "BalanceChangeHistory",
  props: {
    dataList: Array
  },
  methods: {
    tableRowClassName({row, rowIndex}) {
      if (row.reason == 1) {
        return 'cash_out_row';
      }
      return '';
    }
  }
}
</script>

<style>
.el-table tr.el-table__row.cash_out_row {
  background-color: #f0f9eb;
}
</style>



// WEBPACK FOOTER //
// src/pages/providers/balance/BalanceChangeHistory.vue